import { withStyles } from "@material-ui/core/styles";
import React from "react";
import { withRouter } from "react-router-dom";

import AgencyPromo from "../RecruitifiPromo/AgencyPromo";

import RecruiterRegistrationForm from "./RecruiterRegistrationForm";

const style = theme => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    marginLeft: "auto",
    marginRight: "auto",
    [theme.breakpoints.down("1120")]: {
      flexDirection: "column",
      alignItems: "center"
    }
  }
});

function RecruiterRegistration({ classes, location }) {
  return (
    <div className={classes.container}>
      <RecruiterRegistrationForm />
      {location.pathname !== "/public/talk-agency-registration" && <AgencyPromo />}
    </div>
  );
}

export default withRouter(withStyles(style)(RecruiterRegistration));
